import React from 'react';
import { Check, X } from 'lucide-react';

import { VERTICAL_OPTIONS } from './affiliateFields';

/**
 * Multi-select for affiliate_clean.vertical.
 *
 * Seven options, so they are all on screen as toggles rather than hidden behind
 * a dropdown — picking two or three is the common case and this makes it one
 * click each.
 *
 * Values already on the row that are not in the canonical set are shown as
 * separate removable chips. They are kept unless the operator explicitly clears
 * them, so opening the modal never quietly rewrites a column.
 */
const VerticalPicker = ({ options = VERTICAL_OPTIONS, selected, custom = [], onChange }) => {
  const toggle = (value) => {
    const next = selected.includes(value)
      ? selected.filter((v) => v !== value)
      : [...selected, value];
    onChange({ selected: next, custom });
  };

  const dropCustom = (value) => {
    onChange({ selected, custom: custom.filter((v) => v !== value) });
  };

  return (
    <div>
      <div className="flex flex-wrap gap-1.5">
        {options.map((option) => {
          const active = selected.includes(option);
          return (
            <button
              key={option}
              type="button"
              onClick={() => toggle(option)}
              className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-medium transition-colors ${
                active
                  ? 'border-blue-500 bg-blue-600 text-white'
                  : 'border-gray-200 bg-white text-gray-600 hover:border-blue-300 hover:text-blue-600 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300 dark:hover:border-blue-500 dark:hover:text-blue-400'
              }`}
            >
              {active && <Check className="h-3 w-3 flex-shrink-0" />}
              {option}
            </button>
          );
        })}
      </div>

      {custom.length > 0 && (
        <div className="mt-2">
          <p className="mb-1 text-[11px] text-gray-400 dark:text-slate-500">
            Already on this row and not in the list — kept unless you remove it:
          </p>
          <div className="flex flex-wrap gap-1.5">
            {custom.map((value) => (
              <span
                key={value}
                className="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-gray-50 px-2 py-0.5 text-xs text-gray-600 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-400"
              >
                {value}
                <button
                  type="button"
                  onClick={() => dropCustom(value)}
                  className="text-gray-400 hover:text-red-500 dark:hover:text-red-400"
                  title={`Remove ${value}`}
                >
                  <X className="h-3 w-3" />
                </button>
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default VerticalPicker;
